"use client";

import { Skeleton } from "@/components/ui/skeleton";

export default function MarketplaceVerticalSnapFeedSkeleton() {
  return (
    <div className="relative z-10 w-full h-full md:h-[calc(100dvh-var(--contest-banner-height,0px)-var(--custom-banner-height,0px))] md:flex md:items-center md:justify-center md:gap-4">
      <div className="relative h-full w-full md:hidden">
        <div className="relative h-full w-full bg-black">
          <Skeleton aria-hidden className="absolute inset-0 rounded-none bg-muted dark:bg-white/5" />
          <div className="absolute inset-0 bg-linear-to-b from-black/20 via-transparent to-black/55" />

          <div className="absolute left-3 z-10 flex items-center gap-2 top-[var(--feed-top-bar-height,4rem)]">
            <Skeleton className="h-9 w-9 shrink-0 rounded-full bg-muted dark:bg-white/10" />
            <div className="flex flex-col items-start gap-1">
              <Skeleton className="h-4 w-24 rounded-full bg-muted dark:bg-white/10" />
              <Skeleton className="h-3 w-16 rounded-full bg-muted dark:bg-white/10" />
            </div>
          </div>

          <div className={`absolute right-3 z-20 flex flex-col items-center gap-2 pt-[calc(var(--feed-top-bar-height,4rem)+4rem)] bottom-56`}>
            <div className="flex flex-col items-center gap-0.5">
              <Skeleton className="h-9 w-9 rounded-full bg-muted dark:bg-white/10" />
            </div>
            <Skeleton className="h-9 w-9 rounded-full bg-muted dark:bg-white/10" />
            <Skeleton className="h-9 w-9 rounded-full bg-muted dark:bg-white/10" />
            <Skeleton className="h-9 w-9 rounded-full bg-muted dark:bg-white/10" />
            <Skeleton className="h-9 w-9 rounded-full bg-muted dark:bg-white/10" />
          </div>

          <div className="absolute bottom-0 left-0 right-0 p-4 space-y-3">
            <div className="flex items-center gap-2 min-w-0">
              <Skeleton className="h-5 flex-1 min-w-0 max-w-[60%] rounded-lg bg-muted dark:bg-white/10" />
              <Skeleton className="h-4 w-4 shrink-0 rounded-full bg-muted dark:bg-white/10" />
              <div className="flex items-center gap-2 shrink-0">
                <Skeleton className="h-6 w-14 rounded-full bg-muted dark:bg-white/10" />
                <Skeleton className="h-6 w-12 rounded-full bg-muted dark:bg-white/10" />
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-8 w-24 rounded-lg bg-muted dark:bg-white/10" />
              <Skeleton className="h-11 flex-1 rounded-full bg-muted dark:bg-white/10" />
            </div>
          </div>
        </div>
      </div>

      <div className="relative h-full w-full md:w-[480px] md:shrink-0 hidden md:block">
        <div
          aria-hidden
          className="relative z-10 h-full w-full overflow-y-scroll snap-y snap-mandatory scrollbar-hide md:w-[520px] md:px-[80px] md:shrink-0 md:overflow-x-visible"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          <div className="h-full w-full snap-start snap-always flex items-center justify-center shrink-0">
            <div className="hidden md:flex relative group items-center justify-center h-full w-full overflow-visible">
              <div className="relative w-[360px] h-[600px] transition-transform duration-300 ease-out">
                <Skeleton aria-hidden className="absolute inset-0 scale-105 blur-2xl opacity-20 rounded-3xl bg-muted dark:bg-white/10" />
                <div className="relative z-10 h-full w-full rounded-[28px] overflow-hidden bg-black border border-border shadow-[0_8px_40px_rgba(0,0,0,0.35)] dark:border-white/10">
                  <Skeleton className="absolute inset-0 bg-muted dark:bg-white/5" />
                  <div className="absolute left-3 top-3 flex items-center gap-2 z-10">
                    <Skeleton className="h-9 w-9 rounded-full bg-white/10" />
                    <div className="flex flex-col gap-1">
                      <Skeleton className="h-4 w-24 rounded-full bg-white/10" />
                      <Skeleton className="h-3 w-16 rounded-full bg-white/10" />
                    </div>
                  </div>
                  <div className="absolute right-3 top-[calc(4rem+4rem)] flex flex-col items-center gap-2 z-10">
                    <Skeleton className="h-9 w-9 rounded-full bg-white/10" />
                    <Skeleton className="h-9 w-9 rounded-full bg-white/10" />
                    <Skeleton className="h-9 w-9 rounded-full bg-white/10" />
                    <Skeleton className="h-9 w-9 rounded-full bg-white/10" />
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 space-y-3">
                    <div className="flex items-center gap-2">
                      <Skeleton className="h-5 flex-1 max-w-[55%] rounded-lg bg-white/10" />
                      <Skeleton className="h-4 w-4 rounded-full bg-white/10" />
                      <Skeleton className="h-6 w-14 rounded-full bg-white/10" />
                      <Skeleton className="h-6 w-12 rounded-full bg-white/10" />
                    </div>
                    <div className="flex items-center gap-3">
                      <Skeleton className="h-8 w-24 rounded-lg bg-white/10" />
                      <Skeleton className="h-11 flex-1 rounded-full bg-white/10" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden md:flex flex-col items-center justify-center gap-2 z-50 md:-ml-8">
        <div className="flex flex-col items-center gap-2">
          <Skeleton className="w-10 h-10 rounded-full bg-muted dark:bg-white/10" />
          <Skeleton className="w-10 h-10 rounded-full bg-muted dark:bg-white/10" />
          <Skeleton className="w-10 h-10 rounded-full bg-muted dark:bg-white/10" />
          <Skeleton className="w-10 h-10 rounded-full bg-muted dark:bg-white/10" />
        </div>
      </div>

      <div
        className="hidden md:block transition-all duration-500 ease-out relative z-50 md:self-start mb-3 w-0 opacity-0 overflow-hidden translate-y-8 pointer-events-none md:ml-0"
        style={{ marginTop: "var(--feed-top-bar-height,4rem)" }}
        aria-hidden
      >
        <div className="w-[min(420px,calc(100vw-520px-6rem))] h-full max-h-[calc(100dvh-var(--feed-top-bar-height,4rem)-1rem)] bg-card rounded-3xl flex flex-col overflow-hidden border border-border dark:border-white/10">
          <div className="p-4 border-b border-border dark:border-white/10 flex items-center gap-3">
            <Skeleton className="h-5 w-40 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full ml-auto" />
          </div>

          <div className="flex-1 overflow-y-auto hide-scrollbar">
            <div className="p-4 space-y-4">
              <div className="flex items-center gap-2 flex-wrap">
                <Skeleton className="h-6 w-20 rounded-full" />
                <Skeleton className="h-6 w-16 rounded-full" />
              </div>

              <div className="space-y-2">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-11/12" />
                <Skeleton className="h-4 w-4/5" />
              </div>

              <div className="pt-2 space-y-2">
                <Skeleton className="h-4 w-24 rounded-full" />
                <Skeleton className="h-3 w-40 rounded-full" />
                <Skeleton className="h-3 w-32 rounded-full" />
                <Skeleton className="h-3 w-28 rounded-full" />
              </div>

              <div className="pt-2 space-y-2">
                <Skeleton className="h-3 w-36 rounded-full" />
                <Skeleton className="h-3 w-28 rounded-full" />
              </div>

              <div className="pt-2 space-y-3">
                <Skeleton className="h-14 w-full rounded-2xl" />
                <Skeleton className="h-28 w-full rounded-2xl" />
              </div>
            </div>
          </div>

          <div className="p-4 border-t border-border bg-card/95 dark:border-white/10 dark:bg-black/50">
            <div className="flex items-center justify-between gap-4">
              <Skeleton className="h-8 w-24 rounded-full" />
              <Skeleton className="h-12 w-44 rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
